import { Suspense, lazy } from 'react'
import { DEV_TOOLS_ENVIRONMENT_CONTAINER_ID, DevToolsPortal, Button } from '@quickmd-llc/design-system'
import { isDevToolsEnabled } from 'features/isDevToolsEnabled'
import { SANDBOX_PAGE_PATH } from 'utils/constants'

const LazyFlagsSection = lazy(() =>
  import('./components/FlagsSection').then((x) => ({
    default: x.FlagsSection,
  })),
)

const LazyDevToolsLogin = lazy(() =>
  import('./components/DevToolsLogin').then((x) => ({
    default: x.DevToolsLogin,
  })),
)

const LazyAnnouncementsSection = lazy(() =>
  import('./components/AnnouncementsSection').then((x) => ({
    default: x.AnnouncementsSection,
  })),
)

/**
 * Provider-dependent DevTools content — portals into the DevTools App tab.
 * If the app crashes, this disappears but core DevTools panels survive.
 */
export function DevToolsAppContent() {
  if (!isDevToolsEnabled) return null

  return (
    <>
      <DevToolsPortal>
        <Button to={SANDBOX_PAGE_PATH} className='w-full'>
          Sandbox
        </Button>
        <Suspense fallback={null}>
          <LazyDevToolsLogin />
        </Suspense>
        {/* Announcement previews sit with the app's own widgets rather than with the environment:
            they stand in fake content, which is a thing about this app's state, not about which
            backend it points at. */}
        <Suspense fallback={null}>
          <LazyAnnouncementsSection />
        </Suspense>
      </DevToolsPortal>

      {/* Flags sit with the environment rather than with the app's own debug widgets — which
          environment a flag came from is the first thing you check when one looks wrong. */}
      <DevToolsPortal specificId={DEV_TOOLS_ENVIRONMENT_CONTAINER_ID}>
        <Suspense fallback={null}>
          <LazyFlagsSection />
        </Suspense>
      </DevToolsPortal>
    </>
  )
}
